import React, { useEffect } from 'react';
import './App.css';

function App() {
  // Function to generate random number within a range
  const random = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  // Function to animate names
  const bounceNames = () => {
    const nameElements = document.querySelectorAll('.name');
    nameElements.forEach(name => {
      // Randomly change the position of each name over time
      setInterval(() => {
        name.style.left = random(0, window.innerWidth) + 'px';
        name.style.top = random(0, window.innerHeight) + 'px';
      }, 2000); // Update position every 2 seconds
    });
  };

  useEffect(() => {
    // Function to create a span for each name and append to body
    const names = ['Devin', 'Maya'];
    names.forEach(name => {
      const nameSpan = document.createElement('span');
      nameSpan.textContent = name;
      nameSpan.className = 'name';
      nameSpan.style.position = 'absolute';
      nameSpan.style.fontFamily = 'Arial, sans-serif';
      nameSpan.style.fontSize = '3rem';
      nameSpan.style.color = '#61dafb';
      nameSpan.style.left = random(0, window.innerWidth) + 'px';
      nameSpan.style.top = random(0, window.innerHeight) + 'px';
      document.body.appendChild(nameSpan);
    });

    bounceNames();
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        {/* The names will be animated and displayed by the useEffect hook */}
      </header>
    </div>
  );
}

export default App;
